import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { NgClass } from '@angular/common';
import { PSDocumentPage } from '../../model/document-page.interface';
import { PageImageService } from '../../service/page-image.service';

@Component({
  selector: 'shared-dp-preview-page-thumbnail',
  imports: [NgClass],
  templateUrl: './preview-page-thumbnail.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreviewPageThumbnailComponent {
  readonly selected = input.required<boolean>();
  readonly index = input.required<number>();
  readonly page = input.required<PSDocumentPage>();

  protected readonly pageImageService = inject(PageImageService);
}
